<template>
  <div class="history-content">
    <div class="historyContent-btn">
      <div class="historyBtn-title">
        <p class="historyTitle-name">{{$t("mobileTimePeriod")}}</p>
        <p class="historyTitle-export" @click="mobileExportData">{{$t("mobileExport")}}</p>
      </div>
      <div class="historyBtn-box1">
        <div @click="setFive(1)" :class="index == 1 ? 'historyBox1-minute1' : 'historyBox1-minute'">{{$t("mobileFive")}}</div>
        <div @click="setTen(2)" :class="index == 2 ? 'historyBox1-minute1' : 'historyBox1-minute'">{{$t("mobileTen")}}</div>
        <div @click="setHour(3)" :class="index == 3 ? 'historyBox1-minute1' : 'historyBox1-minute'">{{$t("mobileHour")}}</div>
        <div @click="setDay(4)" :class="index == 4 ? 'historyBox1-minute1' : 'historyBox1-minute'">{{$t("mobileDay")}}</div>
<!--        <div @click="setMonth(5)" :class="index == 5 ? 'historyBox1-minute1' : 'historyBox1-minute'">{{$t("mobileMonth")}}</div>-->
      </div>
<!--      <div class="historyBtn-box2">-->
<!--        <div @click="setDay(4)" :class="index == 4 ? 'historyBox2-day1' : 'historyBox2-day'">日</div>-->
<!--        <div @click="setMonth(5)" :class="index == 5 ? 'historyBox2-day1' : 'historyBox2-day'">月</div>-->
<!--      </div>-->
    </div>
    <div :class="valueList.length > 0 ? 'historyContent-chart' : 'historyContent-chart1'">
      <div class="proCharts" id="myChart" ></div>
      <div class="historyContent-sum" :style="setDisplay()">{{$t("mobileSum")}}：{{cumulative}}mm</div>
    </div>
  </div>
</template>

<script>
  import {getTimeDeviceHistory} from "../untils/api/home"
  import moment from "moment"
  import router from "../router";
  export default {
    name: 'mobileStatistics',
    components: {},
    data() {
      return {
        index: 0,
        option: {},
        deviceInfo: {},
        key: '',
        timeList: [],
        valueList: [],
        exportList: [],
        titleName: '',
        //minuteNum: 0,
        cumulative: '',
        load: null,
      }
    },

    mounted() {
      if (window.history && window.history.pushState) {
        // 历史记录 插入当前界面
        history.pushState(null, null, document.URL)
        window.addEventListener('popstate', this.goBack, false)
      }
    },

    destroyed() {
      window.removeEventListener('popstate', this.goBack, false)
    },

    methods: {
      /**
       * 初期化清空所有变量
       * @param deviceInfo
       * @param key
       */
      initMobileStatistics(deviceInfo, key) {
        this.deviceInfo = deviceInfo;
        this.key = key;
        this.option = {};
        this.myCharts();//加载折线图
        this.timeList = [];
        this.valueList = [];
        this.exportList = [];
        this.titleName = '';
        //this.minuteNum = 0;
        this.index = 0;
        this.cumulative = '';
        this.load = null;
      },

      /**
       * 五分钟雨量
       * @param i
       */
      setFive(i){
        this.index = i;
        this.titleName = this.$t("mobileFiveMinuteRainfall");
        let startTime = new Date(moment().subtract(2,"hours")).getTime();
        let endTime = new Date(moment()).getTime();
        let interval = 1000 * 60 * 5;
        this.setLoading();//加载画面
        this.getMinuteInfo(startTime, endTime, interval, 0);//获取历史数据
      },

      /**
       * 十分钟雨量
       * @param i
       */
      setTen(i) {
        this.index = i;
        this.titleName = this.$t("mobileTenMinuteRainfall");
        let startTime = new Date(moment().subtract(5,"hours")).getTime();
        let endTime = new Date(moment()).getTime();
        let interval = 1000 * 60 * 10;
        this.setLoading();//加载画面
        this.getMinuteInfo(startTime, endTime, interval, 1)//获取历史数据
      },

      /**
       * 小时雨量
       * @param i
       */
      setHour(i) {
        this.index = i;
        this.titleName = this.$t("mobileOneHourRainfall");
        let startTime = new Date(moment().subtract(1,"days")).getTime();
        let endTime = new Date(moment()).getTime();
        let interval = 1000 * 60 * 60;
        this.setLoading();//加载动画
        this.getMinuteInfo(startTime, endTime, interval, 2);
      },

      /**
       * 获取分钟历史数据
       * @param startTime
       * @param endTime
       * @param interval
       * @param ban
       */
      getMinuteInfo(startTime, endTime, interval, ban) {
        this.timeList = [];
        this.valueList = [];
        this.exportList = [];
        //this.minuteNum++;
        this.option = {};
        this.myCharts();//加载折线图
        let sum = 0;
        getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, startTime, endTime, interval, 'MAX').then(response => {
          //this.minuteNum = 0;
          for(let obj in response){
            for(let i = response[obj].length - 1; i > 0; i--) {
              let num;
              if(parseFloat(response[obj][i].value) - parseFloat(response[obj][i - 1].value) < 0) {
                num = parseFloat(parseFloat(response[obj][i].value).toFixed(2));
                sum += num;
              } else {
                num = parseFloat((parseFloat(response[obj][i].value) - parseFloat(response[obj][i -1].value)).toFixed(2));
                sum += num;
              }
              this.timeList.push(this.dateFormat(response[obj][i].ts).substring(5));
              this.valueList.push(num);
              this.exportList.push({
                ts: this.dateFormat(response[obj][i].ts),
                value: num
              })
            }
          }
          if(this.timeList.length > 0){
            this.setOptionStyle(0);//加载折线图柱状图
          }
          this.cumulative = sum.toFixed(2); //获取累计值
          this.load.close();//关闭加载画面
        }).catch(error => {
          // if(this.minuteNum > 4) { //访问数据库次数大于5次
          //   this.minuteNum = 0;
          //   this.load.close();//关闭加载画面
          //   console.log("error",error)
          // } else {
          //   //再次访问api
          //   if(ban === 0) {
          //     this.setFive(1);
          //   } else if(ban === 1) {
          //     this.setTen(2);
          //   } else {
          //     this.setHour(3);
          //   }
          // }
          this.load.close();//关闭加载画面
          console.log("error",error)
        })
      },

      /**
       * 日雨量
       * @param i
       */
      setDay(i) {
        this.index = i;
        this.titleName = this.$t("mobileDayRain");
        let month = moment().format('MM') == 1 ? 12 : moment().format('MM') - 1; //获取上个月
        let year = moment().format('MM') == 1 ? moment().format('YYYY') - 1 : moment().format('YYYY');//获取上一年
        let dayLength;
        let arrTime = [];
        if(month == 1|| month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {//上个月为31天
          dayLength = 31;
        } else if((year % 4 == 0 && year % 100 != 0 || year % 400 == 0) && month == 2) {//上个月为闰年2月
          dayLength = 29;
        } else if(!(year % 4 == 0 && year % 100 != 0 || year % 400 == 0)  && month == 2) {//上个月为平年2月
          dayLength = 28;
        } else {//其他
          dayLength = 30;
        }

        for(let i = 0; i < dayLength; i++) {//根据上个月 获取每一天的开始时间以及结束时间
          let startTime = new Date(moment().startOf('day').subtract(i, "days")).getTime();
          let endTime = new Date(moment(startTime).add(5, 'minutes')).getTime();
          arrTime.push(startTime, endTime);
        }
        this.setLoading();
        this.setDayInfo(arrTime, dayLength);
      },

      /**
       * 月雨量
       * @param i
       */
      setMonth(i) {
        this.index = i;
        this.titleName = this.$t("mobileMonthRain");
        let arrTime = [];
        for(let i = 0; i < 12; i++) {//获取近1年内每个月的开始时间以及结束时间
          let startTime = new Date(moment().startOf('month').subtract(i,"months")).getTime();
          let endTime = new Date(moment(startTime).add(5,"minutes")).getTime();
          arrTime.push(startTime, endTime);
        }
        this.setLoading();
        this.setDayInfo(arrTime, 12);
      },

      /**
       * 根据日 周 获取历史数据
       * @param arrTime
       * @param dayLength
       */
      setDayInfo(arrTime, dayLength) {
        let interval = 1000 * 60 * 10;
        let totalRain = [];
        for(let i = 0; i < arrTime.length; i+=2) {
          getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, arrTime[i], arrTime[i + 1], interval, 'MAX').then(response => {
            let dayRain = {};
            if(JSON.stringify(response) === "{}"){//未查出数据赋值为‘0’
              dayRain.ts = arrTime[i + 1];
              dayRain.value = '000';
              totalRain.push(dayRain);
            } else {
              for(let obj in response){
                dayRain.ts = response[obj][0].ts;
                dayRain.value = parseFloat(response[obj][0].value);
                totalRain.push(dayRain);
              }
            }
            // for(let obj in response){
            //   for(let j = 0; j < response[obj].length; j++) {
            //     dayRain.ts = response[obj][j].ts;
            //     dayRain.value = response[obj][j].value;
            //     totalRain.push(dayRain);
            //   }
            // }
            if(totalRain.length === dayLength){//排序
              totalRain.sort(function (a, b) {
                return -(a.ts - b.ts);
              })
              for(let j = 0; j < totalRain.length; j++) {
                if(j === 0 && totalRain[j].value === '000'){//赋值为‘0’并且不是最后一位 将'0'赋值为前一位一致
                  totalRain[j].value = 0;
                } else if(j !== 0 && totalRain[j].value === '000'){//赋值为‘0’并且是最后一位 将'0'赋值为0
                  totalRain[j].value = totalRain[j - 1].value;
                }
              }
              this.dayStyle(totalRain);
            }
          }).catch(error => {
            console.log("error", error)
          })
        }
      },

      /**
       * 将筛选出的数据进行整合
       * @param totalRain
       */
      dayStyle(totalRain) {
        this.option = {};
        this.myCharts();//加载折线图
        this.timeList = [];
        this.valueList = [];
        this.exportList = [];
        let sum = 0;
        for(let i = 0; i < totalRain.length -1; i++){
          let num;
          if((totalRain[i].value - totalRain[i + 1].value) < 0){
            num = parseFloat(parseFloat(totalRain[i].value).toFixed(2));
            sum += num;
          } else {
            num = parseFloat((totalRain[i].value - totalRain[i + 1].value).toFixed(2));
            sum += num;
          }
          this.timeList.push(this.dateFormat(totalRain[i].ts).substring(5));
          this.valueList.push(num);
          this.exportList.push({
            ts: this.dateFormat(totalRain[i].ts),
            value: num
          })
        }
        if(this.timeList.length > 0) {
          //this.setOptionStyle();///加载折线图柱状图
          this.titleName === this.$t("mobileDayRain") ? this.setOptionStyle(1) : this.setOptionStyle(0)
        }
        this.cumulative = sum.toFixed(2);//获取累计值
        this.load.close();
      },

      /**
       * 加载动画设置
       */
      setLoading() {
        this.load = this.$loading({
          lock: true,
          text: this.$t("mobileLoad"),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      },

      /**
       * 柱状图折线图设置
       */
      setOptionStyle(colorBan) {
        this.option = {
          // color:['rgb(8,252,7)',],
          color: ['#FEC00A',],
          title: {
            text: this.titleName,
            left: 'center', //居中
            textStyle: {
              color: '#ffffff',
              fontSize: 20,
              lineHeight: 35,
              fontWeight: 'normal'
            }

          },
          tooltip: { //提示框
            trigger: 'axis',
            backgroundColor: "rgba(128, 128, 128, 0.5)",
            borderWidth: "1", //边框宽度设置1
            borderColor: "rgba(49, 73, 99, 1)", //设置边框颜色
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'line' // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '8%',
            top:'12%',
            containLabel: true //grid区域是否包含坐标轴的刻度标签
          },
          xAxis: {
            type: 'category', //坐标轴类型。
            boundaryGap: true, //坐标轴两边留白策略
            data: this.timeList,
            offset: 8,
            axisLabel: {//坐标轴刻度标签的相关设置
              // rotate: 30,
              interval: 'auto',
              rotate: -50,
              show: true,
              textStyle: {
                color: '#fff',
                fontSize :10//字体大小
              },
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                // color:'#3a4650'// rgb(2,121,253)
                color: 'rgba(231, 244, 255, 0.2)'
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            }
          },
          yAxis: {
            name: this.$t("mobileValue") + '(mm)',
            type: 'value',
            nameTextStyle:{
              color:'#fff',
            },
            show: true, //隐藏坐标
            axisLabel: { //y轴的坐标文字
              show: true, //不显示坐标控件
              textStyle: {
                color: '#fff' //文字的颜色
              },
            },
            // max:this.max,//最大值
            // min:this.min,
            splitLine:{  //坐标在grid区域的分割线
              show: false,// 不显示网格
              lineStyle: { //设置分割线的样式(图表横线颜色)
                color: ['#153a8a'] //网格颜色
              }
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                color:'rgba(231, 244, 255, 0.2)'//#3a4650  rgb(2,121,253) #3a4650
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            },
          },
          series: [
            {
              type: 'line',
              data: this.valueList,
              symbolSize: 10,
              smooth: true,
              animationDuration: 1000,
              lineStyle:{
                color:'#FEC00A'
              },
              tooltip: { //提示框
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                },
              },
            },
            {
              type: 'bar',
              data: this.valueList,
              itemStyle:{
                normal: {
                  label: {
                    show: true, //开启显示数值
                    position: 'top', //数值在上方显示
                    textStyle: {  //数值样式
                      color: '#ffffff',   //字体颜色
                      fontSize: 10  //字体大小
                    }
                  },
                  //color:'#17B3A3',
                  color:  function (arg) {
                    if(colorBan === 1){
                      if(arg.value >= 50) {
                        return 'red';
                      } else if(arg.value >= 25) {
                        return 'orange';
                      } else if(arg.value >= 10) {
                        return 'yellow'
                      } else if(arg.value > 0) {
                        return 'blue'
                      } else {
                        return '#17B3A3'
                      }
                    } else {
                      return '#17B3A3'
                    }
                  }
                }
              },
              tooltip: {
                trigger: "axis",
                show: false,
              }
            },
          ],
          dataZoom: [
            {
              endValue: 3, //一次显示10个
              type: 'slider',//有滑动条
              show: true,//是否显示滑动条
              xAxisIndex: [0],//开始下标
              handleSize: 0,//滑动条的左右2个滑动条大小
              height: 20, //滑动条高度
              left: "0%",//左边距离
              right: "0%",//右边距离
              bottom: 0,//底部距离
              // borderColor: "#3a4650", //边框颜色
              borderColor: "#101f3e", //边框颜色
              fillerColor: "#4C7C98",//选中区域的背景色#345A7C#4878fe
              borderRadius: 5,//边框弧度
              //backgroundColor: "#1c2735",//未选区域中的背景色
              backgroundColor:'#0b2d4c',
              showDataShadow: false, //是否显示数据阴影
              showDetail:false,//拖动时是否显示数值
              realtime: true,// 是否实时更新
              filterMode: "filter",
            },
            {
              //左右滑动
              type: "inside",
              show: true,
              xAxisIndex: [0],
              start: 0,
              end: 100,
            }
          ]
        }
        this.myCharts();//加载折线图
      },

      /**
       * 显示图标
       */
      myCharts(){
        document.getElementById("myChart").removeAttribute("_echarts_instance_");
        let myChartOption = this.$echarts.init(document.getElementById('myChart'));
        myChartOption.setOption(this.option);
        //图表自适应
        window.addEventListener("resize",function(){
          myChartOption.resize()  // myChart 是实例对象
        })
      },

      /**
       * 图标是否显示
       * @returns {{display: string}}
       */
      setDisplay() {
        if(this.valueList.length === 0){
          return {
            display: 'none'
          };
        }
      },

      /**
       * 导出数据
       */
      mobileExportData(){
        let name = this.titleName;
        let that = this;
        if (that.exportList.length === 0) {
          // alert("该时间区间内没有数据，请重新选择");
          that.$message({
            showClose: true,
            type: "warning",
            message: this.$t("mobileNoData")
          });
          return;
        }
        const {export_json_to_excel} = require('../vendor/Export2Excel');
        const tHeader = [this.$t("time"), this.$t("value"),];
        const filterVal = ['ts', 'value',];
        const list = that.exportList;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data,  name + " " +  this.$t("dataList"));

      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },

      /**
       * 时间格式化
       * @param timestamp
       * @returns {string}
       */
      dateFormat(timestamp) {
        if(timestamp && timestamp !== ''){
          let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
          return dateStr;
        }
        return "-";
      },

      /**
       * 返回
       */
      goBack() {
        if(this.load !== null){
          this.load.close();
          this.load = null;
        }
        localStorage.clear();
        router.replace("/");
      },
    }
  }
</script>

<style lang="less">
  @media screen and (max-width: 500px) {
    .el-loading-spinner .el-loading-text {
      font-size:4vw;
    }
    .el-icon-loading {
      font-size: 10vw;
    }
  }
</style>

<style lang="less" scoped>
  @media screen and (max-width: 500px){
    .history-content {
      width: 100%;
    }

    .historyContent-btn {
      width: 100%;
      height: 22vw;
      position: absolute;
      top: 0.5%;

      .historyBtn-title {
        display: flex;
        justify-content: space-between;
        margin-top: 1%;

        .historyTitle-name {
          font-family: SimSun;
          font-size: 4vw;
          margin-left: 3%;
        }

        .historyTitle-export {
          font-family: SimSun;
          font-size: 5vw;
          margin-right: 3%;
          color: #70eef4;
        }
      }

      .historyBtn-box1{
        width: 90%;
        margin-left: 5%;
        height: 9vw;
        display: flex;
        justify-content: space-between;
        text-align: center;
        font-size: 5vw;
        line-height: 9vw;
        font-family: SimSun;
        margin-top:1%;

        .historyBox1-minute {
          width: 20%;
          height: 100%;
          color: #ffffff;
          border: thin double #3A5275;
        }

        .historyBox1-minute1 {
          width: 20%;
          height: 100%;
          color: #ffffff;
          border: thin double #2ac7c9;
          background-color: #2ac7c9;
        }
      }

      /*.historyBtn-box2 {*/
      /*  width: 60%;*/
      /*  margin-left: 20%;*/
      /*  height: 9vw;*/
      /*  display: flex;*/
      /*  justify-content: space-between;*/
      /*  text-align: center;*/
      /*  font-size: 6vw;*/
      /*  line-height: 9vw;*/
      /*  font-family: SimSun;*/
      /*  margin-top: 1%;*/

      /*  .historyBox2-day {*/
      /*    width: 50%;*/
      /*    height: 100%;*/
      /*    color: #ffffff;*/
      /*    border: thin double #3A5275;*/
      /*  }*/

      /*  .historyBox2-day1 {*/
      /*    width: 50%;*/
      /*    height: 100%;*/
      /*    color: #ffffff;*/
      /*    border: thin double #2ac7c9;*/
      /*    background-color: #2ac7c9;*/
      /*  }*/
      /*}*/
    }

    .historyContent-chart {
      width: 100%;
      top: 23vw;
      position: absolute;
      bottom: 0%;
      //background-color: #3a4650;
      background-color: rgba(37, 70, 95, 0.5);
    }

    .historyContent-chart1 {
      width: 100%;
      top: 23vw;
      position: absolute;
      bottom: 0%;
    }

    .proCharts {
      width: 100%;
      height: 100%;
    }

    .historyContent-sum {
      position: absolute;
      width: 30vw;
      top: 5%;
      right: 0;
      z-index: 999;
      margin-top: 1vw;
      text-align: left;
      color: #83e2fd;
      font-size: 3.5vw;
      font-family: SimSun
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MobileStatistics.vue